import React, { useState, useEffect } from "react";
import axios from "../api/api";
import AddressBook from "./AddressBook"; // Import component sổ địa chỉ
import "./CustomerProfile.css";
import Layout from '../components/Layout';

const CustomerProfile = () => {
    const [customer, setCustomer] = useState(null);
    const [customerId, setCustomerId] = useState(null);
    const [formData, setFormData] = useState({
        fullName: "",
        phone: "",
        avatar: null,
        birthday: "",
        gender: "Khác",
    });

    useEffect(() => {
        const fetchCustomerProfile = async () => {
            try {
                const response = await axios.get(`/customer-profile/get-profile`);
                setCustomer(response.data);
                setCustomerId(response.data._id); // Lấy `customerId` từ API
                setFormData({
                    fullName: response.data.fullName,
                    phone: response.data.phone,
                    birthday: response.data.birthday ? response.data.birthday.split("T")[0] : "",
                    gender: response.data.gender,
                });
            } catch (error) {
                console.error("Error fetching customer profile:", error);
            }
        };

        fetchCustomerProfile();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
    };

    const handleFileChange = (e) => {
        setFormData((prevData) => ({ ...prevData, avatar: e.target.files[0] }));
    };

    const handleSaveChanges = async () => {
        const data = new FormData();
        data.append("fullName", formData.fullName);
        data.append("phone", formData.phone);
        data.append("birthday", formData.birthday);
        data.append("gender", formData.gender);
        if (formData.avatar) {
            data.append("avatar", formData.avatar);
        }

        try {
            const response = await axios.put(`/customer-profile/${customerId}`, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            alert("Cập nhật thông tin thành công!");
            // Cập nhật lại state của customer và formData
            setCustomer(response.data); // Dữ liệu mới từ API
            setFormData({
                ...formData,
                avatar: null, // Xóa file avatar sau khi upload
            });

        } catch (error) {
            console.error("Error updating customer profile:", error);
        }
    };

    if (!customer) return <p>Đang tải thông tin...</p>;

    return (
        <Layout>
            <div className="profile-container">
                <h2>Hồ Sơ Khách Hàng</h2>
                <div className="profile-section">
                    <div className="form-group">
                        <label>Email:</label>
                        <p>{customer.email}</p>
                    </div>
                    <div className="form-group">
                        <label>Ảnh hiện tại:</label>
                        {customer.avatar ? (
                            <img
                                src={`${process.env.REACT_APP_API_BASE_URL}/${customer.avatar}`}
                                alt="Avatar"
                                className="current-avatar"
                            />
                        ) : (
                            <p>Chưa có ảnh đại diện</p>
                        )}
                    </div>
                    <div className="form-group">
                        <label>Họ Tên:</label>
                        <input
                            type="text"
                            name="fullName"
                            value={formData.fullName}
                            onChange={handleInputChange}
                            className="form-control"
                        />
                    </div>
                    <div className="form-group">
                        <label>Điện Thoại:</label>
                        <input
                            type="text"
                            name="phone"
                            value={formData.phone}
                            onChange={handleInputChange}
                            className="form-control"
                        />
                    </div>
                    <div className="form-group">
                        <label>Ngày Sinh:</label>
                        <input
                            type="date"
                            name="birthday"
                            value={formData.birthday}
                            onChange={handleInputChange}
                            className="form-control"
                        />
                    </div>
                    <div className="form-group">
                        <label>Giới Tính:</label>
                        <select
                            name="gender"
                            value={formData.gender}
                            onChange={handleInputChange}
                            className="form-control"
                        >
                            <option value="Nam">Nam</option>
                            <option value="Nữ">Nữ</option>
                            <option value="Khác">Khác</option>
                        </select>
                    </div>
                    <div className="form-group">
                        <label>Ảnh Đại Diện Mới:</label>
                        <input
                            type="file"
                            name="avatar"
                            accept="image/*"
                            onChange={handleFileChange}
                            className="form-control"
                        />
                    </div>
                    <button className="btn btn-primary" onClick={handleSaveChanges}>
                        Lưu Thay Đổi
                    </button>
                </div>

                <hr />

                <h3>Quản lý các địa chỉ nhận hàng</h3>
                {customerId && <AddressBook customerId={customerId} />}
            </div>
        </Layout>
    );
};

export default CustomerProfile;
